/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Underline_Event_TextInputs */

const en_underline_event_text = /** @type {(inputs: Underline_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Underline event text`)
};

const fr_underline_event_text = /** @type {(inputs: Underline_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texte d'événement souligné`)
};

const de_underline_event_text = /** @type {(inputs: Underline_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignistext unterstreichen`)
};

const it_underline_event_text = /** @type {(inputs: Underline_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sottolinea il testo dell'evento`)
};

const ru_underline_event_text = /** @type {(inputs: Underline_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подчеркните текст события`)
};

const es_underline_event_text = /** @type {(inputs: Underline_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subrayar el texto del evento`)
};

const zh_cn2_underline_event_text = /** @type {(inputs: Underline_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用下划线标出事件文本`)
};

const ja_underline_event_text = /** @type {(inputs: Underline_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントテキストに下線を引く`)
};

const hi_underline_event_text = /** @type {(inputs: Underline_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट टेक्स्ट को रेखांकित करें`)
};

const pt_pt2_underline_event_text = /** @type {(inputs: Underline_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sublinhe o texto do evento`)
};

/**
* | output |
* | --- |
* | "Underline event text" |
*
* @param {Underline_Event_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const underline_event_text = /** @type {((inputs?: Underline_Event_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Underline_Event_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_underline_event_text(inputs)
	if (locale === "de") return de_underline_event_text(inputs)
	if (locale === "it") return it_underline_event_text(inputs)
	if (locale === "ru") return ru_underline_event_text(inputs)
	if (locale === "es") return es_underline_event_text(inputs)
	if (locale === "zh-CN") return zh_cn2_underline_event_text(inputs)
	if (locale === "ja") return ja_underline_event_text(inputs)
	if (locale === "hi") return hi_underline_event_text(inputs)
	if (locale === "pt-PT") return pt_pt2_underline_event_text(inputs)
	return en_underline_event_text(inputs)
});